module.exports = __webpack_public_path__ + "img/control_de_calidad_4-3_3072.03653d3f.jpg";